import { render, staticRenderFns } from "./bac.vue?vue&type=template&id=71a8cac1&scoped=true&"
import script from "./bac.vue?vue&type=script&lang=js&"
export * from "./bac.vue?vue&type=script&lang=js&"
import style0 from "./bac.vue?vue&type=style&index=0&id=71a8cac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8cac1",
  null
  
)

export default component.exports